import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAngularSharedDataAccessFeatureFlagApisService } from './services/feature-flags.service';
import { StoreModule } from '@ngrx/store';
import { fromFeatureFlags } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { WebAngularSharedDataAccessFeatureFlagApiEffects } from '../lib/effects/feature-flag.effects';
import { IfFeatureFlagEnabledDirective } from './directives/if-feature-flag-enabled.directive';
import { IfFeatureFlagEnabledAsyncDirective } from './directives/if-feature-flag-enabled-async.directive';
import { IfFeatureFlagDisabledDirective } from './directives/if-feature-flag-disabled.directive';
import { IfFeatureFlagDisbaledAsyncDirective } from './directives/if-feature-flag-disabled-async.directive';
import { WebAngularSharedDataAccessFeatureFlagApiGuard, MaintenanceGuard, WebAngularSharedDataAccessFeatureFlagReadinessApiGuard } from './guards';
import * as i0 from "@angular/core";
export function initFlagServiceFactory(featureFlagSvc) {
    return async () => {
        await featureFlagSvc.configureClient();
    };
}
export class WebAngularSharedDataAccessFeatureFlagApiModule {
    static { this.ɵfac = function WebAngularSharedDataAccessFeatureFlagApiModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedDataAccessFeatureFlagApiModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: WebAngularSharedDataAccessFeatureFlagApiModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            WebAngularSharedDataAccessFeatureFlagApiGuard,
            WebAngularSharedDataAccessFeatureFlagReadinessApiGuard,
            MaintenanceGuard,
            provideAppInitializer(() => {
                const initializerFn = initFlagServiceFactory(inject(WebAngularSharedDataAccessFeatureFlagApisService));
                return initializerFn();
            })
        ], imports: [CommonModule,
            EffectsModule.forFeature([WebAngularSharedDataAccessFeatureFlagApiEffects]),
            StoreModule.forFeature('featureFlags', fromFeatureFlags.featureFlagsReducer),
            EffectsModule.forFeature([WebAngularSharedDataAccessFeatureFlagApiEffects])] }); }
}
//# sourceMappingURL=web-angular-shared-data-access-feature-flag-api.module.js.map